import client from "../client";

interface Request {
  hash: string | null;
}

export interface InformationRefIDResponse {
  Username: string;
  Name: string;
}

export default function API(
  request: Request
): Promise<InformationRefIDResponse> {
  return client
    .get(`members/information_ref_id`, { params: request })
    .then((response) => response.data)
    .then((json) => {
      return json;
    });
}
